import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function finplusSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  page1Overlay: Ref<boolean>,
  creditLimit: Ref<string>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  const exist = ref(false);

  const requestModel2 = {
    // dropOffStep: "S1",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      basicInformation: {
        // title: ccFormValue.value.value.basicInformation.title,
        fullName: ccFormValue.value.basicInformation.name,
        idTypeCode: ccFormValue.value.basicInformation.idType,
        idNo: ccFormValue.value.basicInformation.idNo,
        oldIc:
          ccFormValue.value.basicInformation.idType == "1"
            ? ""
            : ccFormValue.value.basicInformation.oldIc,
        militaryNo:
          ccFormValue.value.basicInformation.idType == "1"
            ? ""
            : ccFormValue.value.basicInformation.militaryNo,
        nationalityCode: ccFormValue.value.basicInformation.nationality,
        dateOfBirth: ccFormValue.value.basicInformation.dob,
        emailAddress: ccFormValue.value.basicInformation.email,
        mobileCountryCode: ccFormValue.value.basicInformation.countryCode,
        mobileNumber: ccFormValue.value.basicInformation.mobileNo,
        homePhoneCountryCode:
          ccFormValue.value.basicInformation.homePhoneNo != ""
            ? ccFormValue.value.basicInformation.homeCountryCode
            : "",
        homePhoneNumber: ccFormValue.value.basicInformation.homePhoneNo,
        grossMonthlySalary: ccFormValue.value.basicInformation.grossSalary,
        netMonthlySalary: ccFormValue.value.basicInformation.netSalary,
        professionCode: ccFormValue.value.basicInformation.profession,
        professionOthers: ccFormValue.value.basicInformation.others,
        anyLoan:
          ccFormValue.value.basicInformation.question1 == "Yes" ? true : false,
        repayment: ccFormValue.value.basicInformation.repayment,
      },
    },
  };

  if (
    ccFormValue.value.basicInformation.idType == "0" &&
    ccFormValue.value.ekyc.preStatus != "" &&
    ccFormValue.value.preAss.webFormRequestId
  ) {
    const requestModel = {
      webFormRequestId: ccFormValue.value.webFormRequestId,
      preRequestId: ccFormValue.value.preAss.webFormRequestId,
      grossSalary: ccFormValue.value.basicInformation.grossSalary,
    };
    MasterService.preAssesmentValidate(requestModel, ccFormValue.value.token)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.responseModel.check == "Exist") {
            exist.value = true;
          } else {
            exist.value = false;
          }
          MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
            .then((res) => {
              if (res.status == 200) {
                if (exist.value == true) {
                  page1Overlay.value = false;
                  jumpStep(0, "", "1");
                } else {
                  const requestModel = {
                    webFormRequestId: ccFormValue.value.webFormRequestId,
                    name: ccFormValue.value.basicInformation.name,
                    icNo: ccFormValue.value.basicInformation.idNo,
                    dateOfBirth: ccFormValue.value.basicInformation.dob,
                    cardBusinessCode: prop.cardId,
                    nationalityCode:
                      ccFormValue.value.basicInformation.nationality,
                    phoneNo:
                      ccFormValue.value.basicInformation.countryCode +
                      ccFormValue.value.basicInformation.mobileNo,
                    grossIncome:
                      ccFormValue.value.basicInformation.grossSalary.toString(),
                    netIncome:
                      ccFormValue.value.basicInformation.netSalary.toString(),
                    refNo: ccFormValue.value.refNo,
                  };
                  MasterService.preAssesment(
                    requestModel,
                    ccFormValue.value.token
                  )
                    .then((res) => {
                      if (res.status == 200) {
                        // page3Overlay.value = false;
                        ccFormValue.value.preAss.webFormRequestId =
                          res.data.responseModel.webFormRequestId;
                        ccFormValue.value.dsrBurst =
                          res.data.responseModel.dSRStatus;
                        ccFormValue.value.dropOffStep = 5;
                        creditLimit.value =
                          res.data.responseModel.preAssessLimit;
                        ccFormValue.value.ctosScore =
                          res.data.responseModel.ctosScore;
                        if (
                          res.data.responseModel.preAssessStatus == "DECLINED"
                        ) {
                          page1Overlay.value = false;
                          jumpStep(14, "denied2", "3");
                        } else {
                          ccFormValue.value.ekyc.preStatus =
                            res.data.responseModel.preAssessStatus;
                          page1Overlay.value = false;
                          jumpStep(0, "", "1");
                        }
                      }
                    })
                    .catch((e) => {
                      if (e.response.data.code == "WB-401") {
                        // EndSession
                        isTimeOut.value = false;
                        isSessionEnd.value = true;
                      }
                      page1Overlay.value = false;
                      ccFormValue.value.ekyc.preStatus = "DOWN";
                      jumpStep(0, "", "1");
                    });
                }
              }
            })
            .catch((e) => {
              page1Overlay.value = false;
              if (e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
            });
        }
      })
      .catch((e) => {
        if (e.response.data.code == "WB-401") {
          // EndSession
          isTimeOut.value = false;
          isSessionEnd.value = true;
        }
        page1Overlay.value = false;
        jumpStep(14, "denied2", "3");
      });
  } else {
    MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
      .then((res) => {
        if (res.status == 200) {
          if (exist.value == true) {
            page1Overlay.value = false;
            jumpStep(0, "", "1");
          } else {
            const requestModel = {
              webFormRequestId: ccFormValue.value.webFormRequestId,
              name: ccFormValue.value.basicInformation.name,
              icNo: ccFormValue.value.basicInformation.idNo,
              dateOfBirth: ccFormValue.value.basicInformation.dob,
              cardBusinessCode: prop.cardId,
              nationalityCode: ccFormValue.value.basicInformation.nationality,
              phoneNo:
                ccFormValue.value.basicInformation.countryCode +
                ccFormValue.value.basicInformation.mobileNo,
              grossIncome:
                ccFormValue.value.basicInformation.grossSalary.toString(),
              netIncome:
                ccFormValue.value.basicInformation.netSalary.toString(),
              refNo: ccFormValue.value.refNo,
            };
            MasterService.preAssesment(requestModel, ccFormValue.value.token)
              .then((res) => {
                if (res.status == 200) {
                  // page3Overlay.value = false;
                  ccFormValue.value.preAss.webFormRequestId =
                    res.data.responseModel.webFormRequestId;
                  ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
                  ccFormValue.value.dropOffStep = 5;
                  creditLimit.value = res.data.responseModel.preAssessLimit;
                  ccFormValue.value.ctosScore =
                    res.data.responseModel.ctosScore;
                  if (res.data.responseModel.preAssessStatus == "DECLINED") {
                    page1Overlay.value = false;
                    jumpStep(14, "denied2", "3");
                  } else {
                    ccFormValue.value.ekyc.preStatus =
                      res.data.responseModel.preAssessStatus;
                    page1Overlay.value = false;
                    jumpStep(0, "", "1");
                  }
                }
              })
              .catch((e) => {
                if (e.response.data.code == "WB-401") {
                  // EndSession
                  isTimeOut.value = false;
                  isSessionEnd.value = true;
                }
                page1Overlay.value = false;
                ccFormValue.value.ekyc.preStatus = "DOWN";
                jumpStep(0, "", "1");
              });
          }
        }
      })
      .catch((e) => {
        page1Overlay.value = false;
        if (e.response.data.code == "WB-401") {
          // EndSession
          isTimeOut.value = false;
          isSessionEnd.value = true;
        }
      });
  }
}
